import React from 'react';
import { Dialog } from '@headlessui/react';

const ProductVariationListModal = ({
  isOpen,
  setOpen,
  productVariants,
  orderList,
  setOrderList,
  title,
  formId,
  type,
  billType,
  productVariantIndex
}) => {
  const handleSelectVariant = (selectedVariantId, selectedVariantName, selectedVariantPrice) => {
    const updatedOrderList = [...orderList];
    updatedOrderList[productVariantIndex] = {
      ...updatedOrderList[productVariantIndex],
      selectedVariantId,
      selectedVariantName,
      selectedVariantPrice
    };
    setOrderList(updatedOrderList);
  };

  const getSelectedVariantId = () => {
    // const item = orderList.find((item) => item.type === type && item.title === title);
    // return item?.selectedVariantId || null;
  };

  const selectedVariantId = orderList[productVariantIndex]?.selectedVariantId || null;
  console.log("productVariantIndex............in variant modal ", productVariantIndex);
  console.log("selectedVariantId..............in variant modal ", selectedVariantId)
  console.log("prodcutVariants..............in variant modal ", productVariants)
  // return (
  //   <Dialog open={isOpen} onClose={() => setOpen(false)} className="relative z-50">
  //     <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
  //     <div className="fixed inset-0 flex items-center justify-center p-4">
  //       <Dialog.Panel className="w-full max-w-md rounded bg-white p-6 shadow-xl">
  //         <Dialog.Title className="text-xl font-semibold mb-4">{title} Variants</Dialog.Title>

  //         <form id={formId} className="space-y-3">
  //           {productVariants?.map((variant) => (
  //             <label
  //               key={variant.id}
  //               className="flex items-center justify-between px-4 py-2 border rounded cursor-pointer hover:bg-gray-100"
  //             >
  //               <div>
  //                 <p className="font-medium">{variant.name}</p>
  //                 {variant.price && <p className="text-sm text-gray-500">Price: {variant.price}</p>}
  //               </div>
  //               <input
  //                 type="checkbox"
  //                 checked={selectedVariantId === variant.id}
  //                 onChange={() => handleSelectVariant(variant.id)}
  //                 className="w-5 h-5 text-blue-600 border-gray-300 rounded"
  //               />
  //             </label>
  //           ))}
  //         </form>

  //         <div className="mt-6 flex justify-end space-x-3">
  //           <button
  //             onClick={() => setOpen(false)}
  //             className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
  //           >
  //             Close
  //           </button>
  //         </div>
  //       </Dialog.Panel>
  //     </div>
  //   </Dialog>
  // );
    return (
    <div className="space-y-4">
      {console.log("billType ", billType)}
      <h2 className="text-lg font-semibold text-center">{title}</h2>

      <form id={formId} className="space-y-3 max-h-[300px] overflow-y-auto px-2">
        {productVariants?.map((variant) => (
          <label
            key={variant.id}
            className="flex items-center justify-between px-4 py-2 border rounded cursor-pointer hover:bg-gray-100"
          >
            <div>
              <p className="font-medium">{variant.name}</p>
              {variant.price && (
                <p className="text-sm text-gray-500">Price: {billType === "purchase" ? 0 : variant.price}</p>
              )}
            </div>
            <input
              type="checkbox"
              checked={selectedVariantId === variant.id}
              onChange={() => handleSelectVariant(variant.id, variant.name, billType === "purchase" ? 0 : variant.price)}
              className="w-5 h-5 text-blue-600 border-gray-300 rounded"
            />
          </label>
        ))}
      </form>

      {/* Close button */}
      <div className="flex justify-end pt-2">
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ProductVariationListModal;